/**
 * Where Tarifs et abonnements is, from the URL hash, so every view is a link
 * that can be shared:
 *
 * - `#billing` is the prices, by country then plan;
 * - `#billing?tab=promos` the promos, `#billing?tab=discounts` the discounts;
 * - `#billing?tab=discounts&pro=<workerId>` opens the new-discount form with
 *   that pro already filled in, for the link on a pro's page.
 */

export const BILLING_TABS = ["prices", "promos", "discounts"] as const;
export type BillingTab = (typeof BILLING_TABS)[number];

export type BillingRoute = {
  tab: BillingTab;
  /** The pro a discount is being offered to, when arriving from their page. */
  workerId: string | null;
};

export function parseBillingHash(hash: string): BillingRoute {
  const [, search = ""] = hash.replace(/^#\/?billing/, "").split("?", 2);
  const params = new URLSearchParams(search);
  const asked = params.get("tab");
  const tab = BILLING_TABS.includes(asked as BillingTab) ? (asked as BillingTab) : "prices";
  return { tab, workerId: params.get("pro")?.trim() || null };
}

export function billingHref(tab: BillingTab = "prices", workerId: string | null = null): string {
  const params = new URLSearchParams();
  if (tab !== "prices") params.set("tab", tab);
  if (workerId) params.set("pro", workerId);
  const query = params.toString();
  return query ? `#billing?${query}` : "#billing";
}

/** The link a pro's page offers: the discounts tab, with them already picked. */
export function discountForProHref(workerId: string): string {
  return billingHref("discounts", workerId);
}
